import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, DateDecoder, EnumDecoder, field, NumberDecoder, StringDecoder } from '@simonbackx/simple-encoding';
export var CustomerNotificationType;
(function (CustomerNotificationType) {
    CustomerNotificationType["Promotion"] = "Promotion";
    CustomerNotificationType["Reminder"] = "Reminder";
    CustomerNotificationType["Account"] = "Account";
})(CustomerNotificationType || (CustomerNotificationType = {}));
export var NotificationPreference;
(function (NotificationPreference) {
    NotificationPreference["Off"] = "Off";
    /**
     * @deprecated No longer offered in the app — muting sound is handled by the OS
     * notification settings. Kept so stored settings JSON and older clients still
     * decode; the backend treats Silent as Loud (see resolveNotificationPreference).
     */
    NotificationPreference["Silent"] = "Silent";
    NotificationPreference["Loud"] = "Loud";
})(NotificationPreference || (NotificationPreference = {}));
export class CustomerNotificationPreferences extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.promotion = NotificationPreference.Loud;
        this.reminder = NotificationPreference.Loud;
        this.account = NotificationPreference.Loud;
    }
}
__decorate([
    field({ decoder: new EnumDecoder(NotificationPreference) })
], CustomerNotificationPreferences.prototype, "promotion", void 0);
__decorate([
    field({ decoder: new EnumDecoder(NotificationPreference) })
], CustomerNotificationPreferences.prototype, "reminder", void 0);
__decorate([
    field({ decoder: new EnumDecoder(NotificationPreference) })
], CustomerNotificationPreferences.prototype, "account", void 0);
export class CustomerNotificationResponse extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.id = "";
        this.type = CustomerNotificationType.Promotion;
        this.title = "";
        this.body = "";
        this.promotionId = null;
        this.createdAt = new Date();
        this.readAt = null;
    }
}
__decorate([
    field({ decoder: StringDecoder })
], CustomerNotificationResponse.prototype, "id", void 0);
__decorate([
    field({ decoder: new EnumDecoder(CustomerNotificationType) })
], CustomerNotificationResponse.prototype, "type", void 0);
__decorate([
    field({ decoder: StringDecoder })
], CustomerNotificationResponse.prototype, "title", void 0);
__decorate([
    field({ decoder: StringDecoder })
], CustomerNotificationResponse.prototype, "body", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true, nullable: true })
], CustomerNotificationResponse.prototype, "promotionId", void 0);
__decorate([
    field({ decoder: DateDecoder })
], CustomerNotificationResponse.prototype, "createdAt", void 0);
__decorate([
    field({ decoder: DateDecoder, optional: true, nullable: true })
], CustomerNotificationResponse.prototype, "readAt", void 0);
export class CustomerNotificationsListResponse extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.notifications = [];
        this.unread = 0;
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(CustomerNotificationResponse) })
], CustomerNotificationsListResponse.prototype, "notifications", void 0);
__decorate([
    field({ decoder: NumberDecoder })
], CustomerNotificationsListResponse.prototype, "unread", void 0);
export class UnreadCountResponse extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.unread = 0;
    }
}
__decorate([
    field({ decoder: NumberDecoder })
], UnreadCountResponse.prototype, "unread", void 0);
//# sourceMappingURL=CustomerNotification.js.map